import { createContext } from "react";
import axios from "axios";
import React, { useMemo } from "react";
import { AuthContext } from "../Context/Auth";
import { SnackBarContext } from "./SnackBar";
import { useContext } from "react";
import { ApiContext } from "../Context/ApiKey";
import { RestaurantContext } from "./RestaurantData";
import { Group, apiPermissions } from "../Data/ApiPermisstions";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
const AxiosContext = createContext();
function GetThePath(string) {
  let curstring = window.location.pathname;
  console.log("string", string);
  if (!string?.Page) {
    return null;
  }
  let flag = string.Page;

  if (curstring == "/image-library") {
    flag = "image_library";
  }
  if (curstring == "/menu-items") {
    flag = "menu";
  }
  if (curstring == "/menu") {
    flag = "add_item";
  }
  if (curstring === "/") {
    flag = "live_orders";
  }
  if (curstring.includes("order-details")) {
    flag = "order_details";
  }
  if (curstring === "/coupon-analytics") {
    flag = "coupon_analytics";
  }
  if (curstring === "/bulk-export-orders") {
    flag = "bulk_export_orders";
  }
  if (curstring === "/invoices") {
    flag = "invoices";
  }
  if (curstring === "/theme") {
    flag = "theme";
  }
  if (curstring === "/settings") {
    flag = "settings";
  }
  if (string.Page.includes(",")) {
    const returns = string.Page.split(",").filter((page) => {
      return flag == page;
    });
    console.log("flagreturns", returns);
    flag = returns[0];
  }

  return flag;
}
function findClosestMatch(apiList, targetEndpoint) {
  const regexify = (endpoint) =>
    new RegExp(`^${endpoint.replace(/\{.*?\}/g, ".*")}$`);

  return Object.keys(apiList).reduce((closestMatch, endpoint) => {
    const regex = regexify(endpoint);

    if (
      regex.test(targetEndpoint) &&
      (closestMatch === null || endpoint.length < closestMatch.length)
    ) {
      return endpoint;
    }

    return closestMatch;
  }, null);
}
const AxiosProvider = ({ children }) => {
  let apikey = localStorage.getItem("apikey");
  const { user } = useContext(AuthContext);
  const { ApiKey } = useContext(ApiContext);
  const { handleStatus } = useContext(SnackBarContext);
  const { restaurantData } = useContext(RestaurantContext);
  const location = useLocation();
  const per = apiPermissions;
  const ReactcurrentPath = location.pathname;
  const axiosInstance = useMemo(() => {
    console.log(
      "ObjectRest",
      Object.keys(restaurantData),
      Object.keys(restaurantData).length
    );

    const Route = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      headers: {
        Authorization: user,
        ["x-api-key"]: ApiKey ? ApiKey : apikey,
      },
    });
    if (Object.keys(restaurantData).length >= 1) {
      Route.interceptors.request.use((config) => {
        console.log("which request send", config, config?.data?.type);
        if (config?.data?.type === "image/jpeg") {
          config.headers["Content-Type"] = "image/jpeg";
        }
        if (config?.data?.type == "image/png") {
          config.headers["Content-Type"] = "image/png";
        }
        if (config?.data?.type == "application/pdf") {
          config.headers["Content-Type"] = "application/pdf";
        }
        let GetUserRole = localStorage.getItem("COgnitoRole");
        if (GetUserRole === "RestAdmin" || GetUserRole === "Admin") {
          return config;
        } else {
          GetUserRole = JSON.parse(GetUserRole).filter((restid) => {
            return restid.restId === restaurantData.id;
          })[0].role;
        }
        const HitUrl = config.url.split("?")[0];
        let getPath = HitUrl.replace(process.env.REACT_APP_API_URL, "");
        if (
          getPath === "locksetting" ||
          getPath === "restaurant" ||
          getPath == "restaurant/multi/switch"
        ) {
          let pageName = "live_orders";
          config.params = {
            ...config.params,
            PageName: pageName,
          };
          return config;
        }
        if (per[getPath]) {
        } else {
          getPath = findClosestMatch(per, getPath);
        }
        console.log("getPath", getPath);
        const decoded = restaurantData?.groups;
        const role = GetUserRole;
        const get_page = apiPermissions[getPath]; //{Method:"READ",Page:"menu,additem"}
        const pageName = GetThePath(get_page, ReactcurrentPath);
        config.params = {
          ...config.params,
          PageName: pageName,
        };
        console.log("config", config);
        console.log("pageName", pageName);
        if (get_page) {
          const Get_method = get_page.Method;
          if (Get_method) {
            if (decoded?.[role]) {
              const Get_User_Method = decoded[role].permissions[pageName];
              if (Get_User_Method) {
                if (
                  Get_User_Method === "MODIFY" ||
                  Get_User_Method === Get_method
                ) {
                  console.log("allow");
                  return config;
                } else {
                  const error = "access denied";
                  handleStatus({ Open: true, message: error });
                  return Promise.reject(error);
                }
              } else {
                const error =
                  "permission of path could not find in resturantdb";
                handleStatus({ Open: true, message: error });
                return Promise.reject(error);
              }
            } else {
              const error = "role could not find in resturantdb ";
              handleStatus({ Open: true, message: error });
              return Promise.reject(error);
            }
          } else {
            const error = "path method cloud not find in";
            handleStatus({ Open: true, message: error });
            return Promise.reject(error);
          }
        } else {
          const error = "path could not find in constant api permissions";
          handleStatus({ Open: true, message: error });
          return Promise.reject(error);
        }
      });

      Route.interceptors.response.use(
        (response) => {
          return response;
        },
        (error) => {
          console.log("respinse", error?.response);
          handleStatus({
            Open: true,
            message: error?.response?.data?.error
              ? error?.response?.data?.error
                ? error?.response?.data?.error +
                  '"Make sure setting lock disable if update anything"'
                : "access denied Make sure setting lock disable if update anything"
              : error?.includes("mime")
              ? "image type invalid please select different image"
              : error,
          });
          return Promise.reject(error);
        }
      );
    }

    return Route;
  }, [user, restaurantData]);

  return (
    <AxiosContext.Provider value={axiosInstance}>
      {children}
    </AxiosContext.Provider>
  );
};
const Instance = () => {
  return useContext(AxiosContext);
};
export { AxiosProvider, AxiosContext, Instance };
